<template>
  <div class="search_title">
    <div class="search_1">
      <div class="input-with-select">
        <el-input placeholder="请输入职位/公司" v-model="searchVal" @keyup.enter.native="searchData" @focus="$refs.searchHis._show()">
          <JobType :value.sync="jobType" slot="prepend"></JobType>
          <el-button slot="append" class="search_box_index" @click="searchData">搜索</el-button>
        </el-input>
        <!-- 搜索历史 -->
        <HisSearch ref="searchHis" his-key="position_his" @hisSeachBack="onSearchHis" />
      </div>
    </div>
    <div class="search-hot hidden-xs-only" :style="{ width: searchWidth }">
      <b>职位推荐:</b>
      <span v-for="(item, index) in hotKey" :key="index" @click="hotJobClick(item)">{{ item }}</span>
    </div>
    <el-cascader-panel v-if="showType" :options="options"></el-cascader-panel>
  </div>
</template>

<script>
import HisSearch from '@/components/common/HisSearch.vue';
export default {
  components: {
    JobType: () => import('./JobType'),
    HisSearch
  },
  data() {
    return {
      searchVal: '',
      jobType: '',
      showType: false,
      searchWidth: '800px',
      hotKey: ['产品经理', '前端开发工程师', '平面设计', '售前技术支持', '销售专员', '数据分析师', '销售经理']
    };
  },
  created() {
    this.searchWidth = document.documentElement.clientWidth / 2 + 'px';
  },
  mounted() {
    window.addEventListener('mousedown', this.downEvent);
  },
  destroyed() {
    window.removeEventListener('mousedown', this.downEvent);
  },
  methods: {
    downEvent(e) {
      const clickedEl = e.target; //获取被点击的元素
      const el = document.getElementsByClassName('search-find-box')[0]; //获取搜索框元素
      if (!el || !el.contains(clickedEl)) {
        this.$refs.searchHis._hide();
      }
    },
    setData(data) {
      this.hotKey.length = 0;
      if (!data) return;
      data.forEach((item) => {
        this.hotKey.push(item.jobs_name);
      });
    },
    //点击搜索
    searchData() {
      this.goPosition(this.searchVal);
      if (this.searchVal) {
        this.$refs.searchHis.setHistory1(this.searchVal);
      }
    },
    //点击历史记录回调
    onSearchHis(key) {
      this.searchVal = key;
      this.$refs.searchHis._hide();
      this.searchData();
    },
    //热门职位
    hotJobClick(item) {
      this.goPosition(item);
    },
    goPosition(key) {
      this.$router.push({
        path: '/person/positionIndex',
        query: {
          jobType: this.jobType, //职位类别
          city: localStorage.getItem('city_id') || '', //城市id
          key: key
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.search_1 {
  width: 100%;
}

.search_title {
  display: grid;
  justify-content: center;
}

.input-with-select {
  margin: 40px 0px 0px 0px;
  border: 2px solid #00bebd;
  border-radius: 10px;
  background: #fff;
  position: relative;
}

::v-deep .search_1 .el-input-group__prepend {
  border-radius: 10px;
  border: none;
  padding: 11px 0px;
  width: 171px;
  background: #fff;
}

::v-deep .search_1 .el-select .el-input__inner {
  text-align: center;
}

::v-deep .search_1 .el-input__inner {
  border-radius: 10px;
  border: none;
}

::v-deep .search_1 .el-input-group__append {
  width: 128px;
  background: #00bebd;
  border-radius: 0 5px 5px 0;
  color: white;
  font-weight: 700;
  border: none;
  text-align: center;
}

.search-hot {
  height: 30px;
  margin-bottom: 20px;
  overflow: hidden;
  box-sizing: border-box;
  color: #757575;
  font-size: 14px;
  padding: 16px 0 32px 0;
}

.search-hot span {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 6px;
  color: #00a6a7;
  font-size: 14px;
  line-height: 20px;
  padding: 2px 8px;
  margin-right: 12px;
  display: inline-block;
  margin-bottom: 10px;
}

.search-hot b {
  margin-right: 20px;
}

.search-hot span:hover {
  cursor: pointer;
  color: #fcfcfd;
  background: #00bebd;
}
</style>
